<template>
    <!-- {{svgImg}} -->
    <!-- <div v-html="svgImg"></div> -->
    <img
      :src="imgCodeURL"
      align="absmiddle"
      title="看不清，请点击刷新"
      @click="changeImgCode"
      :width="width"
      :height="height"
      class="img_code"
    />
</template>

<script>
export default {
  name: "ImgCode",
  props: {
    width: {
      type: Number,
      default: 114,
    },
    height: {
      type: Number,
      default: 44,
    },
  },
  data() {
    return {
      imgCodeURL: "",
      svgImg: "",
    };
  },
  created() {
    this.changeImgCode();
  },
  methods: {
    changeImgCode() {
      this.$util.api("/common/pic_code", {}, (res) => {
        this.imgCodeURL = res.data.img;
        this.$emit("change",res.data.key);
      });
    },
  },
};
</script>

<style scoped>
.img_code {
  border: 1px solid #d8d8d8;
  cursor: pointer;
  margin-left: 20px;
  /* width: 100%;
  height: 44px;
  overflow: hidden; */
}
</style>